import store from '@/core/store'
import moment from 'moment'
import event from '@/util/event'
import commonService from '@/service/commonService.js'

const consentMixin = {
	data () {
		return {
			enableTermsAndConditionsConsent: this.$appSettings.defaultConfigurations.consentManagement.enableConsent,
			enableTCForceRead: this.$appSettings.defaultConfigurations.consentManagement.enableForceRead,
			checkUpdatedTCFromDay: this.$appSettings.defaultConfigurations.consentManagement.checkUpdatedTCFromDay,
			checkUpdatedTCTillDate: this.$appSettings.defaultConfigurations.consentManagement.checkUpdatedTCTillDate,
			consentConfig: {
				showConsent: false,
				consentArray: [],
				isUpdateConsentAvailable: false,
				routeFrom: ''
			},
			currentDate: moment(new Date()).format('DD-MM-YYYY')
		}
	},
	methods: {
		async getConsentData (partyId, fromAboutSection = false) {
			// Check for updated T&C based on the day of "this.checkUpdatedTCFromDay"
			this.checkUpdatedTCFromDay = this.checkUpdatedTCFromDay.toString().length == 1
				? `0${this.checkUpdatedTCFromDay}` : this.checkUpdatedTCFromDay
			this.checkUpdatedTCFromDate = moment().format(`${this.checkUpdatedTCFromDay}-MM-YYYY`)
			let userStore = store.getters['userStore/userData']
			if ((this.$route.name === 'Home' && (userStore && !userStore?.consentConfig))
				|| (this.currentDate >= this.checkUpdatedTCFromDate)
				|| !this.lastLoginTimeStamp
			) {	
				let filteredConsentsList = []
				let checkForUpdatedConsent = []
				let storeData = store.getters['userStore/userData']
				let { partyType, partySubType, partyCategory } = storeData.consentQueryParam
				let queryParams = {
					customerId: partyId,
					customerType: partyType,
					activeFlag: 'Y',
					customerSubType: partySubType,
					customerCategory: partyCategory
				}
				let consentsList = await commonService.latestCustomerConsents(queryParams)
				if (consentsList && consentsList.consents.length >= 1) {
					filteredConsentsList = consentsList?.consents?.reduce((acc, cur) => ((cur && Boolean(cur.latestConsentVersion) && acc.push(cur.consentCode)), acc), [])
					consentsList?.customerConsents.forEach(consent => {
						if (consent.latestConsentVersion && consent.latestConsentVersion > consent.consentVersion) {
							checkForUpdatedConsent.push(consent)
						}
					})
					if (checkForUpdatedConsent && checkForUpdatedConsent?.length > 0) {
						filteredConsentsList = [...filteredConsentsList, ...checkForUpdatedConsent.reduce((acc, cur) => ((cur && Boolean(cur.latestConsentVersion) && acc.push(cur.consentCode)), acc), [])]
						this.consentConfig.isUpdateConsentAvailable = (this.checkUpdatedTCTillDate > this.currentDate && this.lastLoginTimeStamp) ? true : false
					}
					if (filteredConsentsList && filteredConsentsList?.length) {
						this.consentConfig.consentArray = await Promise.allSettled(filteredConsentsList.map(consentType => commonService.getActiveConsentInfo(consentType)))
							.then(promises => promises
								.filter(promise => 'contents' in promise.value)
								.map(resp => {  return { consentType: resp.value.entityCode, consentInfo: resp.value } })
							)
						this.consentConfig.showConsent = this.consentConfig.consentArray?.length > 0
						store.dispatch('userStore/setUserData', { consentConfig: this.consentConfig })
					} else {
						this.checkIfNavigatable()
					}
				} else if (consentsList && consentsList.consents.length == 0 && consentsList.customerConsents.length >= 1) {
					consentsList?.customerConsents.forEach(consent => {
						if (fromAboutSection || consent.latestConsentVersion && consent.latestConsentVersion > consent.consentVersion) {
							checkForUpdatedConsent.push(consent)
						}
					})
					if (checkForUpdatedConsent && checkForUpdatedConsent?.length > 0) {
						filteredConsentsList = checkForUpdatedConsent.reduce((acc, cur) => ((cur && Boolean(cur.latestConsentVersion) && acc.push(cur.consentCode)), acc), [])
						this.consentConfig.isUpdateConsentAvailable = (this.checkUpdatedTCTillDate > this.currentDate && this.lastLoginTimeStamp) ? true : false
					}
					if (filteredConsentsList && filteredConsentsList?.length) {
						this.consentConfig.consentArray = await Promise.allSettled(filteredConsentsList.map(consentType => commonService.getActiveConsentInfo(consentType)))
							.then(promises => promises
								.filter(promise => 'contents' in promise.value)
								.map(resp => {  return { consentType: resp.value.entityCode, consentInfo: resp.value } })
							)
						this.consentConfig.showConsent = this.consentConfig.consentArray?.length > 0
						store.dispatch('userStore/setUserData', { consentConfig: this.consentConfig })
					} else {
						this.checkIfNavigatable()
					}
				} else {
					this.checkIfNavigatable()
				}
			}
		},
		checkIfNavigatable () {
			if (this.$route.name === 'Login') this.getAccInfoAndNavigateToHome()
		},
		async getAccInfoAndNavigateToHome () {
			event.$emit('routeToHome', true)
		}
	}	
}

export default consentMixin
